import React, {Component} from 'react';
import Select from 'react-select';

export default class ContractFundingKAE extends Component {
    constructor(props) {
        super(props);

        this.state = {
            kae_id: 0,
            kae: [],
        };

        this.handleKAEChange = this.handleKAEChange.bind(this);
    }

    componentWillMount() {
        this.setState({
            kae_id: this.props.kaeId,
            kae: window.kae
        });
    }

    handleKAEChange(e) {
        this.setState({kae_id: e.value});
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="kae_id" className="col-md-4 control-label">
                        ΚΑΕ*
                    </label>
                    <div className="col-md-8">
                        <Select name="kae_id"
                                id="kae_id"
                                value={this.state.kae_id}
                                options={this.state.kae}
                                onChange={this.handleKAEChange}>
                        </Select>
                    </div>
                </div>
            </div>
        );
    }
}